import formatContentSelectValue from './formatContentSelectValue'

const contentTypes = {
  curso: ['tipo', 'titulo', 'autores', 'codigo', 'copyright', 'edicao', 'especialidades'],
  livro: [
    'tipo',
    'titulo',
    'autores',
    'isbn',
    'isbnVetorizacao',
    'codigo',
    'copyright',
    'edicao',
    'especialidades'
  ]
}

export const createFormData = formFields => {
  const contentTypeFields = contentTypes[formFields.tipo]
  const data = new FormData()

  if ((contentTypeFields || []).length) {
    for (let field of contentTypeFields) {
      if (Array.isArray(formFields[field])) {
        const contentList = formatContentSelectValue(formFields[field]).map(item => {
          return item.value
        })

        data.append(field, JSON.stringify(contentList))
      } else {
        const currentField =
          field === 'codigo' ? `${formFields[field]}`.toUpperCase() : formFields[field]
        formFields[field] && data.append(field, currentField)
      }
    }
  }

  return data
}



// WEBPACK FOOTER //
// ./src/utils/formatPreRegistrationToSend.js